<template>
    <div class="family-all">
        <div class="container">
            <h1 v-on:click="w()">Product Families / Discounts</h1>

            <div class="card mb-4">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-4">
                    <p class="mb-0" v-if="!discount.enabled">Global discount is <strong>disabled</strong>.</p>
                    <p class="mb-0" v-if="discount.enabled">Global discount is <strong style="color:red">enabled at {{discount.percentage}}%</strong>.</p>
                  </div>

                  <div class="col-sm-8">
                    <b-input-group>
                      <b-input v-model="discountSetter.percentage" type="number" placeholder="Set a global discount percentage (e.g. 8)"></b-input>
                      <b-button type="button" variant="warning" v-on:click="discountSetter.enabled = true; saveDiscount()">Enable</b-button>
                      <b-button type="button" variant="info" v-on:click="discountSetter.enabled = false; saveDiscount()">Disable</b-button>
                    </b-input-group>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="family in families" v-bind:class="{editing: editing(family), images: editingImages(family)}">
                        <div class="d-flex align-items-center">
                            <strong v-if="!editing(family)">{{family.name}} ({{family.prefix}})
                              <span v-if="discount.enabled && discount.percentage && !(parseFloat(family.percentageDiscount) > 0)" style="color:red">{{ discount.percentage }}% discount</span>
                              <span v-if="family.percentageDiscount && parseFloat(family.percentageDiscount) > 0 && discount.enabled && discount.percentage" style="color:red;text-decoration:line-through">{{ discount.percentage }}% discount</span>
                              <span v-if="family.percentageDiscount && parseFloat(family.percentageDiscount) > 0" style="color:red">{{ family.percentageDiscount}}% discount</span>
                            </strong>
                            <b-form-input v-model="family.name" v-if="editing(family)" class="mr-4" placeholder="Full name (e.g. Manhattan, Greenwich)"></b-form-input>
                            <b-form-input v-model="family.prefix" v-if="editing(family)" class="mr-4" placeholder="Prefix (e.g. MAN, GRE)"></b-form-input>
                            <b-form-input v-model="family.percentageDiscount" v-if="editing(family)" class="mr-4" placeholder="Percentage discount (e.g. 8)"></b-form-input>

                            <div class="btn-group ml-auto">
                                <b-button type="button" class="mr-2" v-on:click="edit(family)" v-if="!editing(family) && !editingImages(family)">
                                    Edit
                                </b-button>

                                <b-button type="button" class="mr-2" variant="success" v-on:click="save(family)" v-if="editing(family) || editingImages(family)">
                                    Save
                                </b-button>

                                <b-button type="button" class="mr-2" variant="danger" v-on:click="del(family)" v-if="editing(family)">
                                    Delete
                                </b-button>

                                <b-button type="button" v-on:click="cancel()" v-if="editing(family) || editingImages(family)">
                                    Cancel
                                </b-button>

                                <b-button type="button" v-on:click="images(family)" v-if="!editing(family) && !editingImages(family)">
                                    Images
                                </b-button>
                            </div>
                        </div>

                        <div class="mt-4" v-if="editingImages(family)">
                            <h3>Product Master</h3>
                            <product-images v-bind:product="family" type="master" editable="true" default-message="Upload product master image here" min-width="2400" min-height="2400" max-images="1"></product-images>

                            <hr />

                            <h3>Website Hero (New Website)</h3>
                            <product-images v-bind:product="family" type="hero_2021" editable="true" default-message="Upload hero image here" min-width="660" min-height="400" max-images="1"></product-images>

                            <hr />

                            <h3>Website Hero (Old Website)</h3>
                            <p>This image will be used as a fallback if no image is provided for "Website Hero (New Website)"</p>
                            <product-images v-bind:product="family" type="hero" editable="true" default-message="Upload hero image here" min-width="1200" min-height="800" max-images="1"></product-images>

                            <hr />

                            <h3>Additional Images</h3>
                            <product-images v-bind:product="family" type="additional" editable="true" default-message="Upload additional images here" min-width="600" min-height="600" max-images="12"></product-images>

                            <hr />

                            <h3>Line Drawings</h3>
                            <product-images v-bind:product="family" type="line" editable="true" default-message="Upload line drawings here" min-width="600" min-height="600" max-images="12"></product-images>

                            <hr />

                            <h3>High-Res / Traditional</h3>
                            <product-images v-bind:product="family" type="highres" editable="true" default-message="Upload high-res/traditional images here" min-width="600" min-height="600" max-images="999"></product-images>

                            <hr />

                            <h3>Other</h3>
                            <product-images v-bind:product="family" type="other" editable="true" default-message="Upload other images here" min-width="600" min-height="600" max-images="999"></product-images>
                        </div>
                    </li>
                </ul>
            </div>

            <b-button type="button" size="lg" class="ml-auto mr-auto mt-4 d-block" variant="success" v-on:click="create()">Create Family</b-button>
        </div>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
import Simplert from 'vue2-simplert'
import ProductImages from './ProductImages.vue'

export default {
  name: 'familyAll',
  props: ['fb'],
  components: {
    Simplert,
    ProductImages
  },
  firebase () {
    return {
      families: this.fb.database().ref('families').orderByChild('name'),
      discount: {
        source: this.fb.database().ref('globalDiscount'),
        asObject: true,
        readyCallback () {
          this.discountSetter = {
            enabled: this.discount.enabled,
            percentage: this.discount.percentage
          }
        }
      }
    }
  },
  data () {
    return {
      editingKey: null,
      editingImagesKey: null,
      discountSetter: {
        enabled: false,
        percentage: 0
      }
    }
  },
  methods: {
    edit (family) {
      this.editingImagesKey = null
      this.editingKey = family['.key']
    },
    editing (family) {
      return this.editingKey === family['.key']
    },
    del (family) {
      this.$firebaseRefs.families.child(family['.key']).remove()
      this.$refs.simplert.openSimplert({
        title: 'Deleted',
        type: 'info',
        message: 'The product family and all associated images have been deleted'
      })
    },
    images (family) {
      this.editingKey = null
      this.editingImagesKey = family['.key']
    },
    editingImages (family) {
      return this.editingImagesKey === family['.key']
    },
    save (family) {
      let f = this.fb.database().ref('families/' + family['.key'])
      delete family['.key']
      f.set(family).then(() => {
        this.$refs.simplert.openSimplert({
          title: 'Saved',
          type: 'info',
          message: 'Saved'
        })

        this.editingKey = null
      })
    },
    cancel () {
      this.editingKey = null
      this.editingImagesKey = null
    },
    create () {
      let push = this.$firebaseRefs.families.push({
        name: 'New Product Family'
      })
      this.edit(push)
    },
    saveDiscount () {
      if (this.discountSetter.enabled) {
        if (!this.discountSetter.percentage) {
          this.$refs.simplert.openSimplert({
            title: 'Discount Required',
            type: 'error',
            message: 'Please set a percentage to enable the discount'
          })
          return
        }
        if (!parseFloat(this.discountSetter.percentage) || parseFloat(this.discountSetter.percentage) < 0.1 || parseFloat(this.discountSetter.percentage) > 100) {
          this.$refs.simplert.openSimplert({
            title: 'Discount Error',
            type: 'error',
            message: 'Please enter a number between 0.1 and 100 to enable the discount.'
          })
          return
        }
      }
      this.fb.database().ref('globalDiscount').set({
        enabled: this.discountSetter.enabled,
        percentage: this.discountSetter.percentage
      }).then(() => {
        if (!this.discountSetter.enabled) {
          this.$refs.simplert.openSimplert({
            title: 'Discount Disabled',
            type: 'info',
            message: 'The global discount has been disabled'
          })
        } else {
          this.$refs.simplert.openSimplert({
            title: 'Discount Disabled',
            type: 'info',
            message: 'The global discount has been enabled and set to ' + this.discountSetter.percentage + '%'
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FamilyAll.vue